import styled from '@emotion/styled';
import { useListingContext } from '~/editor/plugin/ListingPlugin';

const Section = styled.section`
	background: #f5f5f5;
	padding: 2rem 1.5rem 3rem;
`;

const Inner = styled.div`
	max-width: 96rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		flex-direction: row;
		justify-content: space-between;
	}
`;

const PriceBlock = styled.div`
	text-align: center;
`;

const PriceLabel = styled.div`
	font-size: 1rem;
	color: #6b7280;
`;

const PriceValue = styled.div`
	font-size: 3.5rem;
`;

const Stats = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 2rem;
`;

const Stat = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	min-width: 140px;
`;

const StatValue = styled.div`
	font-size: 2rem;
	font-weight: 300;
	white-space: nowrap;
`;

function formatLotSize(lotAcres?: number, lot?: number) {
	if (lotAcres) {
		return `${lotAcres.toFixed(2)} acres`;
	}
	if (lot) {
		return `${lot.toLocaleString()} lot`;
	}
	return null;
}

export default function ListingBlockZeta() {
	const listing = useListingContext();
	const lotSize = formatLotSize(listing.lot_acres, listing.lot);

	return (
		<Section id="overview">
			<Inner>
				<PriceBlock>
					<PriceLabel>Offered At</PriceLabel>
					{listing.price_formatted && <PriceValue>${listing.price_formatted}</PriceValue>}
					<PriceLabel>3% Buyers Agent Compensation</PriceLabel>
				</PriceBlock>
				<Stats>
					{listing.beds != null && <Stat><StatValue>{listing.beds} Beds</StatValue></Stat>}
					{listing.baths != null && <Stat><StatValue>{listing.baths} Baths</StatValue></Stat>}
					{listing.sqft != null && <Stat><StatValue>{listing.sqft.toLocaleString()} Sqft</StatValue></Stat>}
					{lotSize && <Stat><StatValue>{lotSize}</StatValue></Stat>}
				</Stats>
			</Inner>
		</Section>
	);
}
